import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  label?: ReactNode;
  endLabel?: ReactNode;
  disabled?: boolean;
}

export function LabelPanel({ label, endLabel, disabled }: Props) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
    >
      {label && (
        <Typography
          variant="subtitle2"
          component="div"
          sx={theme => ({
            color: theme.palette.grey[disabled ? 400 : 900],
          })}
        >
          {label}
        </Typography>
      )}

      {endLabel && (
        <Typography
          variant="body3"
          component="div"
          sx={theme => ({
            color: theme.palette.grey[disabled ? 400 : 600],
            textAlign: 'right',
            width: label ? 'auto' : '100%',
          })}
        >
          {endLabel}
        </Typography>
      )}
    </Box>
  );
}
